import message from 'antd/lib/message';
import { t } from '../../../app/i18n';
import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../api';
import {
  createApiActionCreators,
  createActionCreator,
  createReducer,
  createActionType,
  REQUEST,
  SUCCESS,
  FAILURE,
} from '../../../common/utils/reduxHelpers';
import { fetchLoanActions } from '../../loan-management/ducks';

export const FETCH_PENALTY_FEES = 'penalty-fees/FETCH';
export const FETCH_PENALTY_FEES_BY_LOAN_ID = 'penalty-fees/FETCH_BY_LOAN_ID';
export const STORNO_PENALTY_FEE = 'penalty-fees/STORNO';

export const fetchPenaltyFeesAction = createApiActionCreators(FETCH_PENALTY_FEES);
export const fetchPenaltyFeesByLoanIdAction = createApiActionCreators(FETCH_PENALTY_FEES_BY_LOAN_ID);
export const stornoPenaltyFeeRequest = createActionCreator(STORNO_PENALTY_FEE);

const initialState = {
    items: [],
    pagination: {
      current: null,
      pageSize: null,
      total: null,
    },
    isLoading: false,
  };

const penaltyFees = createReducer(initialState, {
    [FETCH_PENALTY_FEES]: {
        [REQUEST]: (state) => ({
            ...state,
            isLoading: true,
        }),
        [SUCCESS]: (state, payload) => ({
            isLoading: false,
            items: payload.items,
            pagination: payload.pagination
        }),
        [FAILURE]: () => ({
            items: [],
            isLoading: false,
        })
    },
    [FETCH_PENALTY_FEES_BY_LOAN_ID]: {
        [REQUEST]: (state) => ({
            ...state,
            isLoading: true,
        }),
        [SUCCESS]: (state, payload) => ({
            isLoading: false,
            items: payload,
        }),
        [FAILURE]: () => ({
            items: [],
            isLoading: false,
        })
    },
});

export default penaltyFees;

const selectState = state => state.penaltyFees;
export const selectIsLoading = state => selectState(state).isLoading;
export const selectPenaltyFees = state => selectState(state).items;
export const selectPagination = state => selectState(state).pagination;

function* fetchPenaltyFees({payload}) {
    const resp = yield call(api.fetchPenaltyFees, payload.pagination);

    if (resp.ok) {
        yield put(fetchPenaltyFeesAction.success(resp.data));
    } else {
        yield put(fetchPenaltyFeesAction.failure(resp.error));
    }
}

function* fetchPenaltyFeesByLoanId({payload}) {
    const resp = yield call(api.fetchPenaltyFeesByLoanId, payload);

    if (resp.ok) {
        yield put(fetchPenaltyFeesByLoanIdAction.success(resp.data));
    } else {
        yield put(fetchPenaltyFeesByLoanIdAction.failure(resp.error));
    }
}

function* stornoPenaltyFee({payload}) {
    const resp = yield call(api.stornoPenaltyFee, payload.id);

    if (resp.ok) {
        message.success(t('Sankčný poplatok stornovaný.'), 3);
        yield put(fetchLoanActions.request(payload));
        yield put(fetchPenaltyFeesByLoanIdAction.request(payload.loanId));
    } else {
        message.failure(t('Nastala chyba, kontaktujte prosím technickú podporu.'), 3);
    }
}

export function* penaltyFeesSaga() {
    yield takeLatest(createActionType(FETCH_PENALTY_FEES, REQUEST), fetchPenaltyFees);
    yield takeLatest(createActionType(FETCH_PENALTY_FEES_BY_LOAN_ID, REQUEST), fetchPenaltyFeesByLoanId);
    yield takeLatest(STORNO_PENALTY_FEE, stornoPenaltyFee);
}


// WEBPACK FOOTER //
// ./src/features/penalty-fee/ducks/index.js